/**
 * @class App
 * @param element HTMLElement
 * @constructor
 */
function App(element){
	this._element = element;
	this._document = element.ownerDocument;
	this._window = this._document.defaultView;
	this._clickHandlerBound = this._clickHandler.bind(this);
	this._submitHandlerBound = this._submitHandler.bind(this);
	this._loadHandlerBound = this._loadHandler.bind(this);
	this._ideaClickHandlerBound = this._ideaClickHandler.bind(this);

	var iframes = element.getElementsByTagName("iframe");
	this._decorations = new Array(iframes.length);
	for(var iframeIndex = 0, numIframes = iframes.length; iframeIndex < numIframes; iframeIndex++){
		this._decorations[iframeIndex] = new AppDecorationIFrame(iframes[iframeIndex]);
	}

	var elements;
	if((elements = element.getElementsByClassName("app_video")).length){
		this._videoDialog = new AppVideoDialog(elements[0]);
		this._document.addEventListener("click", this._clickHandlerBound, false);
	}

	if((elements = element.getElementsByClassName("app_feedback-ideas-form")).length){
		this._form = elements[0];
		this._form.addEventListener("submit", this._submitHandlerBound, false);
		this._potentialsSubmitters = [];

		for(var formElement, nodeName, type, elementIndex = 0, formElements = this._form.elements, numElements = formElements.length; elementIndex < numElements; elementIndex++){
			formElement = formElements[elementIndex];
			nodeName = formElement.nodeName;
			type = formElement.type;
			// All buttons
			if(
				nodeName == "BUTTON" && type == "submit"
				|| nodeName == "INPUT" && type == "reset"
				|| nodeName == "INPUT" && type == "submit"
				|| nodeName == "INPUT" && type == "image"
			){
				formElement.addEventListener("click", this._ideaClickHandlerBound, false);
				this._potentialsSubmitters.push(formElement);
			}
		}
	}

	// Watch these elements when scroll
	var elementsArray = [];
	// Class list of single elements (test if exist)
	var classes = ["app_summary", "app_video-link-container", "app_screenshot", "app_feedback", "app_feedback-ideas-list"];
	for(var classIndex = 0, numClasses = classes.length; classIndex < numClasses; classIndex++){
		if((elements = element.getElementsByClassName(classes[classIndex])).length){
			elementsArray.push(elements[0]);
		}
	}
	elementsArray = elementsArray.concat(Array.prototype.slice.call(this._element.getElementsByClassName("app_description")));
	this._scrollAnimator = new ScrollAnimator(this._window, elementsArray);

	// Trigger animation
	this._animateDecorationTimeoutID = setTimeout(this._animateDecorations.bind(this), 700);
}

/** @type DocumentView */
App.prototype._window = null;
/** @type HTMLDocument */
App.prototype._document = null;
/** @type HTMLElement */
App.prototype._element = null;
/** @type Array.<AppDecorationIFrame> */
App.prototype._decorations = null;
/** @type AppVideoDialog */
App.prototype._videoDialog = null;
/** @type {ScrollAnimator} */
App.prototype._scrollAnimator = null;
App.prototype._animateDecorationTimeoutID = 0;
App.prototype._clickHandlerBound = null;
App.prototype._loadHandlerBound = null;
App.prototype._ideaClickHandlerBound = null;
App.prototype._form = null;
/** @type XMLHttpRequest */
App.prototype._sender = null;
/** @type FormDataEncoder */
App.prototype._formEncoder = null;
App.prototype._potentialsSubmitters = null;
App.prototype._submitter = null;

App.prototype._animateDecorations = function _animateDecorations(){
	for(var index = 0, num = this._decorations.length; index < num; index++){
		this._decorations[index].state = "target";
	}
};
App.prototype._clickHandler = function _clickHandler(event){
	// If default action is canceled
	if(event.defaultPrevented){
		return;
	}

	/** @type Node */
	// Search clicked links (could be one of the ancestor of the target)
	var element = event.target;
	var location = this._window.location;
	while(element){
		if(element.nodeName == "A"){
			var fragmentID = element.hash.substr(1);
			// If same protocol, hostname, port, pathname and search
			if(
				element.protocol == location.protocol
				&& element.hostname == location.hostname
				// If port undefined: IE give HTMLAnchorElement.port !== window.location.port
				&& (element.port == location.port || element.port == 80 && location.port == "")
				&& element.pathname == location.pathname
				&& element.search == location.search
				&& this._document.getElementById(fragmentID) == this._videoDialog.element
				){
				event.preventDefault();
				this._videoDialog.open();
			}

			return;
		}
		element = element.parentElement;
	}
};

App.prototype._submit = function _submit(){
	// No submitter detected
	if(!this._submitter){
		return;
	}

	if(this._sender){
		this._sender.abort();
	}else{
		this._sender = new XMLHttpRequest();
		this._sender.addEventListener("load", this._loadHandlerBound, false);
		this._formEncoder = new FormDataEncoder();
	}
	//this._form.getAttribute("action")/*field name=action override form.action, use getAttribute instead*/
	this._sender.open(this._form.method, this._form.dataset.action);
	this._sender.setRequestHeader("Content-Type", "application/x-www-form-urlencoded; charset=UTF-8");

	var entries = FormDataReader.getEntries(this._form);
	entries.push(new FormDataEntry(this._submitter.name, this._submitter.value, this._submitter.type));
	this._formEncoder.encode(entries);
	// here: this._formEncoder.readyState == FormDataEncoder.DONE
	this._sender.send(this._formEncoder.result);
};

App.prototype._ideaClickHandler = function _ideaClickHandler(event){
	this._submitter = event.currentTarget;
};

App.prototype._submitHandler = function _submitHandler(event){
	this._submit();
	event.preventDefault();
};

App.prototype._loadHandler = function _loadHandler(event){
	var data = JSON.parse(this._sender.responseText);
	// Update security fields
	this._form.elements.nonce.value = data.nonce;
	if(data.code == 1/*success*/){
		this._submitter.disabled = true;
		this._submitter = null;
	}
};

App.prototype.clear = function clear(){
	for(var iframeIndex = 0, numIframes = this._decorations.length; iframeIndex < numIframes; iframeIndex++){
		this._decorations[iframeIndex].clear();
	}

	if(this._videoDialog){
		this._videoDialog.clear();
	}
	this._document.removeEventListener("click", this._clickHandlerBound, false);

	if(this._form){
		this._form.removeEventListener("submit", this._submitHandlerBound, false);
		for(var elementIndex = 0, numElements = this._potentialsSubmitters.length; elementIndex < numElements; elementIndex++){
			this._potentialsSubmitters[elementIndex].removeEventListener("click", this._ideaClickHandlerBound, false);
		}
	}
	if(this._sender){
		this._sender.removeEventListener("load", this._loadHandlerBound, false);
		this._sender.abort();
	}

	clearTimeout(this._animateDecorationTimeoutID);

	this._scrollAnimator.clear();

	return true;
};